<template>
    <div>
        <div class="transaction-mobile-sec mt-1">
            <select class="form-select tras-slct-drop-box" v-model="selectedStatus" @change="getWalletHistory()"> 
                <option v-for="(item, index) in options" :key="index" :value="item.value">{{ item.label}}</option> 
            </select>
        </div>
        <div class="transaction-mobile-sec">
            <ul class="nav nav-tabs border-0 wallet_trans_head">
                <li class="nav-item" role="presentation">
                    <button @click="selectedType = 0" class="nav-link" :class="{ active: selectedType === 0 }"
                     type="button">{{ $t('all', 'All') }}</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button @click="selectedType = 1" class="nav-link" :class="{ active: selectedType === 1 }"
                     type="button">{{$t('deposit','Deposit')}}</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button @click="selectedType = 2" class="nav-link" :class="{ active: selectedType === 2 }"
                     type="button">{{$t('withdrawal','Withdrawal')}}</button>
                </li>
            </ul>
        </div>
        <div class="tab-content trasactions-content">
            <div class="tab-pane fade show active">
                <div class="wallet-transection-wrapper">
                    <template  v-for="(item, index) in historyData" :key="index">
                        <div class="transactions-m-item">
                            <a  href="javascript:void(0);" class="transactions-container-information-item">
                                <div class="transactionsInformation">
                                    <div class="transactionsInformation-left">
                                        <div class="transactionsInformation-img status successfull" :class="{'statusapproved': item.status == 'approve_completed' , 'statusreject': item.status == 'reject_in_process' || item.status == 'cancelled', 'statusprocessing': item.status == 'pending'}">
                                            <img v-if="['pending','hold'].includes(item.status)" src="@/assets/images/processing-icon.webp" alt="processing">
                                            <img v-if="['approve_completed','approve_in_process'].includes(item.status)" src="@/assets/images/check-mark.png" alt="check-mark">
                                            <img v-if="['reject_in_process','reject_completed','expired','cancelled'].includes(item.status)" src="@/assets/images/request-rejected-icon.png" alt="request-rejected">
                                            <!-- <img v-if="item.status == 4" src="@/assets/images/image (2).png" alt="status"> -->
                                        </div> 
                                        <div class="transactionsInformation-data">
                                            <div class="transactionsInformation-data__id">
                                                {{ toTitleCaseWithSpaces(item?.type) }} Request <span class="badge" :class="getTransactionStatusClass(item?.status)?.class">{{ getTransactionStatus(item?.status)?.label }}</span>
                                            </div>
                                            <div class="transactionsInformation-data__dateTime">{{ $dateTime.getLocalDate(item.completed_at ?? item.created_at, 'DD/MM/YYYY, HH:mm:ss')}}</div>
                                        </div> 
                                    </div>
                                    <div class="transactionsInformation-right m-0">
                                        <div class="transactionsInformation-amount m-0">
                                            <button v-if="['pending','hold','reject_in_process','approve_in_process'].includes(item.status)" type="button" :class="{'rotate-ref_icon': isRefreshing === item.c_a_tid}"
                                                @click="getWalletHistory(item.c_a_tid)" class="trans_refresh_icon">
                                                <img src="@/assets/images/reload.png" alt="reload">
                                            </button>
                                            <span>
                                                {{ item.approved_amount > 0 ? item.approved_amount : item.amount }}
                                            </span>
                                        </div>
                                        <div @click="gotoTransactionDetails(item)" class="transactionsInformation-arrow" v-if="!['pending','approve_in_process','reject_in_process','expired','hold'].includes(item.status)">
                                            <img src="@/assets/images/IconArrow.svg" alt="IconArrow">
                                        </div>
                                        <!-- <div v-if="item.status == 'pending'" class="transactionsInformation-delete" @click="askConfirmation(item.c_a_tid)">
                                            <img src="@/assets/images/delete-btn.png" alt="delete">
                                        </div> -->
                                    </div>
                                    
                                </div>
                            </a>
                        </div>
                    </template>
                </div>
                <div v-if="historyData?.length === 0" class="no-records">
                    <NoDataFound/>
                </div>
            </div>
        </div>
    </div>
    <Confirmation
        @confirm="confirmDelete"
        @cancel="$helper.closeModal('deleteConfirmationModal')"
    />
</template>

<script>
import Confirmation from '@/shared/components/confirmation/Confirmation.vue';
import NoDataFound from '@/shared/components/no-data/NoDataFound.vue';
import { getWalletHistory, cancelRequest, getTransactionStatus } from '@template/utils';
import { defineAsyncComponent } from 'vue';
export default {
    name: 'Wallet History',
    data(){
        return{
            walletHistoryData: null,
            profitLossData: null,
            pageNo: 1,
            totalPage: 0,
            pageEntries: 10,
            formDates:{
                fromDate: '',
                toDate: '',
            },
            options: [
                { label: this.$t('all', 'All'), value: 'all', selected:true },
                { label: this.$t('pending', 'Pending'), value: 'pending', selected:true },
                { label: this.$t('approved', 'Approved'), value: 'approve_completed', selected:true },
                { label: this.$t('rejected', 'Rejected'), value: 'reject_completed', selected:true },
                { label: this.$t('processing', 'Processing'), value: 'processing', selected:true },
                { label: this.$t('expired', 'Expired'), value: 'expired', selected:true },
            ],
            selectedStatus: 'all',
            selectedType: 0, // 1 for deposit, 2 for withdrawal
            isRefreshing: null,
            selectedTransactionId: null,

        }
    },
    components: { 
        NoDataFound,
        Confirmation
    },
    computed: {
        historyData() {
            if (this.selectedType === 0) {
                return this.walletHistoryData;
            } 
            else if(this.selectedType === 1) {
                return this.walletHistoryData?.filter((item) => ['client_deposit','manual_deposit'].includes(item.type));
            }
            else {
                return this.walletHistoryData?.filter((item) => ['client_withdrawal','manual_withdrawal'].includes(item.type));
            }
        },
    },
    created(){
        this.formDates.fromDate = this.$dateTime.getPreviousDate(30);
        this.formDates.toDate = this.$dateTime.getcurrentDate()
        this.getWalletHistory()
    },
    methods:{
        getTransactionStatus,
        toTitleCaseWithSpaces(str) {
            return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
        },
        async cancelRequest(id){
            try{
                let response = await cancelRequest(id);
                 this.getWalletHistory()
            }
            catch(error){
                console.log('cancelRequest', error)
            }
        },
        async getWalletHistory(transactionId = null) {
            try {
                if (transactionId) {
                    this.isRefreshing = transactionId;
                } else {
                    this.$store.dispatch('setGlobalLoader', true);
                }

                let response = await getWalletHistory(this.formDates);

                if (response) {
                    let historyData = response?.walletHistoryData || [];

                    if (this.selectedStatus == 'all') {
                        this.walletHistoryData = historyData
                    } else if (this.selectedStatus == 'processing') {
                        this.walletHistoryData = historyData.filter(history =>
                            ['reject_in_process', 'approve_in_process','hold'].includes(history.status)
                        );
                    }else{
                        this.walletHistoryData = historyData.filter((history) => history.status == this.selectedStatus)
                    }
                }
                setTimeout(() => {
                    this.isRefreshing = null;
                }, 1000);
                if (!transactionId) {
                    this.$store.dispatch('setGlobalLoader', false);
                }
            } catch (error) {
                setTimeout(() => {
                    this.isRefreshing = null;
                }, 1000);
                this.$store.dispatch('setGlobalLoader', false);
                console.log(error);
            }
        },
        gotoTransactionDetails(transaction){
            if(['pending','approve_in_process','reject_in_process','expired'].includes(transaction.status)) return false
            this.$store.dispatch('setTransactionDetails', transaction)
            this.$router.push({ 
                name: 'TransactionDetails', 
                params: { id: transaction.c_a_tid } 
            })
        },
        askConfirmation(id) {
            this.selectedTransactionId = id
            this.$helper.openModal('#deleteConfirmationModal')
        },
        async confirmDelete() {
            this.$helper.closeModal('deleteConfirmationModal')
            await this.cancelRequest(this.selectedTransactionId);
        },
        getTransactionStatusClass(status){
            switch (status) {
                case 'pending':
                    return { label: 'Pending', class: 'bg-pending' };
                case 'approve_completed':
                    return { label: 'Approved', class: 'bg-success' };
                case 'approve_in_process':
                    return { label: 'Approve In Process', class: 'bg-warning' };
                case 'reject_completed':
                    return { label: 'Rejected', class: 'bg-danger' };
                case 'reject_in_process':
                    return { label: 'Reject In Process', class: 'bg-warning' };
                case 'hold':
                    return { label: 'Processing', class: 'bg-pending' };
                case 'expired':
                    return { label: 'Expired', class: 'bg-danger' };
                case 'cancelled':
                    return { label: 'Cancelled', class: 'bg-danger' };
            }
        },
    }
}
</script>